import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { map } from 'rxjs';
import { RESOURCES } from '../constants/resources.constants';

@Injectable({
  providedIn: 'root',
})
export class ApiService {
  private readonly httpClient = inject(HttpClient);
  resources = RESOURCES;

  get(resource: string, params?: any) {
    return this.httpClient.get(resource, { params: params }).pipe(map((res: any) => res));
  }

  put(resource: string, data: any, params?: any) {
    return this.httpClient.put<any>(resource, data, { params: params }).pipe(map((res: any) => res));
  }

  patch(resource: string, data: any, params?: any) {
    return this.httpClient.patch<any>(resource, data, { params: params }).pipe(map((res: any) => res));
  }

  post<T>(resource: string, data: any, params?: any) {
    return this.httpClient.post<T>(resource, data, { params: params }).pipe(map((res: any) => res));
  }

  delete(resource: string, data: any, params?: any) {
    return this.httpClient.delete(resource, { params: params, body: data }).pipe(map((res: any) => res));
  }
}
